import '@/plugins/vee-validate/validators/validate-date'
import '@/plugins/vee-validate/validators/validate-file'
import '@/plugins/vee-validate/validators/validate-url'
import '@/plugins/vee-validate/validators/validate-financial'
import '@/plugins/vee-validate/validators/validate-lexnet'
import '@/plugins/vee-validate/validators/validate-object'
import '@/plugins/vee-validate/validators/validate-only-charnumber'
import '@/plugins/vee-validate/validators/validate-string'
import '@/plugins/vee-validate/validators/validate-unique-code'
import '@/plugins/vee-validate/validators/validation-modes'
